export enum BooleanComparator {
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
}

export enum BrandAffinityComparator {
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
  IS_NOT_SET = 'IsNotSet',
  IS_SET = 'IsSet',
}

export enum CampaignComparator {
  EQUALS = 'Equals',
}

export enum DateComparator {
  AFTER = 'GreaterThan',
  BEFORE = 'LessThan',
  BETWEEN = 'IsBetween',
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
  IS_SET = 'IsSet',
  ON_OR_AFTER = 'GreaterThanOrEqualTo',
  ON_OR_BEFORE = 'LessThanOrEqualTo',
}

export enum GeoLocationComparator {
  CONTAINS = 'Contains',
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
  GREATER_THAN = 'GreaterThan',
  GREATER_THAN_OR_EQUAL = 'GreaterThanOrEqualTo',
  IS_NOT_SET = 'IsNotSet',
  IS_SET = 'IsSet',
  LESS_THAN = 'LessThan',
  LESS_THAN_OR_EQUAL = 'LessThanOrEqualTo',
  MATCHES_REGEX = 'MatchesRegex',
  STARTS_WITH = 'StartsWith',
}

export enum ListComparator {
  DOES_NOT_INCLUDE = 'DoesNotEqual',
  INCLUDES = 'Equals',
}

export enum MessageTypeComparator {
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
}

export enum NumericComparator {
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
  GREATER_THAN = 'GreaterThan',
  GREATER_THAN_OR_EQUAL = 'GreaterThanOrEqualTo',
  IS_SET = 'IsSet',
  LESS_THAN = 'LessThan',
  LESS_THAN_OR_EQUAL = 'LessThanOrEqualTo',
}

export enum StringComparator {
  CONTAINS = 'Contains',
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
  IS_SET = 'IsSet',
  MATCHES_REGEX = 'MatchesRegex',
  STARTS_WITH = 'StartsWith',
}

export type ComparatorType =
  | BooleanComparator
  | BrandAffinityComparator
  | CampaignComparator
  | DateComparator
  | GeoLocationComparator
  | ListComparator
  | MessageTypeComparator
  | NumericComparator
  | StringComparator;
